export const documentFields = {
  Resume: [
    "Email Address",
    "Phone Number",
    "Education Details",
    "Work Experience",
    "Skills",
    "Certifications",
    "References",
    "Objective",
    "Status",
  ],
  Law: [
    "Case Number",
    "Client Name",
    "Case Type",
    "Court Name",
    "Lawyer Name",
    "Filing Date",
    "Case Status",
    "Hearing Date",
    "Case Summary",
    "Related Documents Name",
    "Judge Name",
    "Legal Remarks",
  ],
  Educational: [
    "Student Name",
    "Institution Name",
    "Course / Program Name",
    "Academic Year",
    "Enrollment Number",
    "Grade/Marks",
    "Certificates Issued",
    "Attendance Record",
    "Examination Date",
  ],
  Finance: [
    "Account Holder Name",
    "Amount (Currency)",
    "Payment Due Date",
    "Transaction Date",
    "Payment Method",
    "Interest Rate",
    "Loan Term",
    "Collateral Details",
    "Status",
    "Tax Information",
  ],
  Medical: [
    "Patient Name",
    "Doctor Name",
    "Hospital/Clinic Name",
    "Treatment Plan",
    "Medical History",
    "Insurance Details",
    "Date of Visit",
    "Next Appointment Date",
  ],
  RealEstate: [
    "Property Title/Name",
    "Address of Property",
    "Property Type",
    "Area (sq. ft.)",
    "Purchase Date",
    "Price/Value",
    "Property Status",
    "Agent Details",
  ],
  Taxation: [
    "Taxpayer Name",
    "PAN/Tax Identification Number",
    "Income Details",
    "Tax Payable",
    "Tax Paid",
    "Refund Status",
    "Filing Date",
    "Supporting Documents",
  ],
  HumanResources: [
    "Employee Name",
    "Employee ID",
    "Designation",
    "Department",
    "Date of Joining",
    "Salary/Compensation",
    "Performance Review",
    "Leave Balance",
    "Training Programs",
  ],
  TravelTourism: [
    "Traveler's Name",
    "Passport Number",
    "Destination",
    "Travel Dates",
    "Booking ID",
    "Accommodation Details",
    "Transportation Details",
    "Itinerary",
    "Travel Insurance",
  ],
  Government: [
    "Full Name",
    "Voter ID",
    "Residential Address",
    "Permanent Address",
    "Phone Number",
    "Email Address",
    "Aadhar Number",
  ],
  RetailEcommerce: [
    "Product Name",
    "Stock Keeping Unit",
    "Category",
    "Price",
    "Quantity",
    "Supplier Name",
    "Order Date",
    "Delivery Date",
    "Customer Feedback",
    "Invoice Number",
  ],
};

export default documentFields;
